import React from 'react';
import {Box, Button, Chip, IconButton, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {CARD_SX, Eyebrow} from '../interventions/v2/primitives.js';
import PointMap from '../interventions/v2/PointMap.js';
import {ConteneurIcon} from '../../../utils/ui/Icons/ConteneurIcon.js';
import {helper} from '../../../utils/helper';

const Row = ({label, children}) => (
    <Box sx={{py: 0.75}}>
        <Eyebrow sx={{mb: 0.25}}>{label}</Eyebrow>
        <Typography component="div" sx={{fontSize: 14, fontWeight: 600, color: '#2D333B'}}>{children}</Typography>
    </Box>
);

/**
 * Rail de contexte 340 px (clic sur un PAV) : réutilise PointMap, ConteneurIcon et les couleurs de déchet de la vue
 * intervention v2 ; « Figer ce jour » ajoute le verrou au volet sans rejouer. Les lignes vides disparaissent.
 * AJOUT À VALIDER : contenu propre au simulateur (collecte, journée affectée, raison) dans le gabarit ContextRail.
 */
function AtelierRail({fiche, position, onFermer, onFiger}) {
    if (!fiche) return null;
    return (
        <Box sx={{...CARD_SX, width: 340, maxWidth: '100%', flex: 'none', overflowY: 'auto', maxHeight: '100%'}} data-testid="rail-pav">
            {position && <Box sx={{p: 1.5, pb: 0}}><PointMap point={{latitude: position[0], longitude: position[1]}} releve={null}/></Box>}
            <Box sx={{p: 2.5}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <Typography sx={{fontSize: 20, fontWeight: 800, color: '#0F2D69', lineHeight: 1.2}}>{fiche.nomenclature}</Typography>
                    <IconButton size="small" aria-label="Fermer la fiche" onClick={onFermer}><CloseIcon fontSize="small"/></IconButton>
                </Box>
                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1, mb: 1}}>
                    {fiche.dechetType && <Chip size="small" label={fiche.dechetType} sx={helper.getColorForDechetType(fiche.dechetType)}/>}
                    {fiche.bacs != null && <Chip size="small" icon={<ConteneurIcon/>} label={`${fiche.bacs} bac${fiche.bacs > 1 ? 's' : ''}`}/>}
                </Box>
                {fiche.flux.length > 0 && <Row label="Flux">{fiche.flux.join(', ')}</Row>}
                {fiche.collecte.length > 0 &&
                    <Row label="Jours de collecte">
                        {fiche.collecte.map((l, i) => <div key={i}>{l.flux} · {l.texte}</div>)}
                    </Row>}
                {fiche.affectations.length > 0 &&
                    <Row label="Journée affectée">
                        {fiche.affectations.map((a, i) => (
                            <Box key={i} sx={{mb: 0.5}}>
                                {a.texte}{a.partie ? ` · stock ${a.partie}` : ''}{a.fige ? ' · figé' : ''}
                                <div>
                                    <Button size="small" color="primary" sx={{borderRadius: 999, px: 0}} onClick={() => onFiger(fiche.nomenclature, a.date)}>
                                        Figer ce jour
                                    </Button>
                                </div>
                            </Box>
                        ))}
                    </Row>}
                {fiche.nonAffecte && <Row label="Non affecté"><span style={{color: '#B22222'}}>Visite non affectée</span></Row>}
                {fiche.raison && <Row label="Raison">{fiche.raison}</Row>}
            </Box>
        </Box>
    );
}

export default AtelierRail;
